<template>
  <div class="shockData">
    <!-- 公共title -->
    <Top
      :name="$t('High Frequency Vibration Spectrum')"
      :show-button="false"
    ></Top>
    <Select :currentChecked="currentChecked"></Select>
    <div class="chart-list">
      <div :id="roots_pump_m_id" class="chart"></div>
      <div :id="roots_pump_id" class="chart"></div>
      <div :id="screw_pump_m_id" class="chart"></div>
      <div :id="screw_pump_id" class="chart"></div>
    </div>
  </div>
</template>

<script>
import Select from "../Select.vue";
import { getCurrentMonthDate, HighlineChart } from "@/minix.js";
import { data, data1, data2 } from "./data1";
import moment from "moment";
export default {
  name: "shockData",
  data() {
    return {
      currentChecked: "3",
      roots_pump_m_id: `roots_pump_m_${+new Date()}`,
      roots_pump_id: `roots_pump_${+new Date()}`,
      screw_pump_m_id: `screw_pump_m_${+new Date()}`,
      screw_pump_id: `screw_pump_${+new Date()}`,
      xAxisData: [],
      selectCheckedName: this.$t("Roots pump drive end - horizontal direction"),
      selectedTitleName: this.$t(
        "Roots pump drive end - horizontal direction-title"
      )
    };
  },
  computed: {
    selectCheckedList() {
      return [
        {
          name: this.$t("Roots pump motor non-drive end level"),
          title: this.$t("Roots pump motor non-drive end level-title"),
          type: "1",
          checked: false
        },
        {
          name: this.$t("Roots pump motor drive end level"),
          title: this.$t("Roots pump motor drive end level-title"),
          type: "2",
          checked: false
        },
        {
          name: this.$t("Roots pump drive end - horizontal direction"),
          title: this.$t("Roots pump drive end - horizontal direction-title"),
          type: "3",
          checked: false
        },
        {
          name: this.$t("Roots pump non-drive end level"),
          title: this.$t("Roots pump non-drive end level-title"),
          type: "4",
          checked: false
        },
        {
          name: this.$t("Screw pump motor non-driven end level"),
          title: this.$t("Screw pump motor non-driven end level-title"),
          type: "5",
          checked: false
        },
        {
          name: this.$t("Screw pump motor drive end level"),
          title: this.$t("Screw pump motor drive end level-title"),
          type: "6",
          checked: false
        },
        {
          name: this.$t("Screw pump drive end level"),
          title: this.$t("Screw pump drive end level-title"),
          type: "7",
          checked: false
        },
        {
          name: this.$t("Screw pump non-driven end level"),
          title: this.$t("Screw pump non-driven end level-title"),
          type: "8",
          checked: false
        }
      ];
    }
  },
  watch: {
    currentChecked: {
      handler(val) {
        this.$nextTick(() => {
          this.selectCheckedName = this.selectCheckedList[val - 1].name;
          this.selectedTitleName = this.selectCheckedList[val - 1].title;
          this.chartOne();
          this.chartTwo();
          this.chartThree();
          this.chartFour();
        });
      }
    },
    "$i18n.locale": {
      handler() {
        this.initChart();
      },
      deep: true
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      let dayNum = getCurrentMonthDate();
      for (let i = 0; i < dayNum; i++) {
        this.xAxisData.push(i + 1);
      }
      this.chartOne();
      this.chartTwo();
      this.chartThree();
      this.chartFour();
    },
    setRandom(max, min) {
      let random = Math.floor(Math.random() * (max - min + 1)) + min;
      return random;
    },
    setAxisData() {
      let dayNum = getCurrentMonthDate();
      let axisData = [];
      for (let i = 0; i < dayNum; i++) {
        axisData.push(
          this.setRandom(dayNum * 1.5, dayNum * 0.5, getCurrentMonthDate())
        );
      }
      return axisData;
    },
    moment,
    chartOne() {
      let option = {
        // name: this.selectedTitleName + `-${this.$t("Speed RMS")}（mm/s）`,
        name: `${this.$t("Speed RMS")}（mm/s）`,
        nameType: this.$t("Trend graph"),
        legend: [
          this.$t("X-directional vibration"),
          this.$t("Y-directional vibration")
        ],
        data: data.map(item => {
          return item[1];
        }),
        date: data.map(items => {
          return moment(Number(items[0])).format("YYYY/MM/DD HH:mm:ss");
        }),
        max: 25,
        min: 10,
        threshold: 20,
        color: "#7CFFB2",
        chartDom: this.roots_pump_m_id
      };

      HighlineChart(option);
    },
    chartTwo() {
      let option = {
        // name:
        //   this.selectedTitleName +
        //   `-${this.$t("Horizontal-acceleration")}（m/s^2`,
        name: `${this.$t("Horizontal-acceleration")}（m/s^2`,
        nameType: this.$t("Waveform graph"),

        legend: [
          this.$t("X-directional vibration"),
          this.$t("Y-directional vibration")
        ],
        data: data1.map(item => {
          return Number(item[1]) / 2;
        }),
        date: data1.map(items => {
          return Number(items[0]).toFixed(3);
        }),
        max: 10,
        min: 0,

        threshold: 2000,
        color: "#7CFFB2",

        chartDom: this.roots_pump_id
      };
      HighlineChart(option);
    },
    chartThree() {
      let option = {
        // name: this.selectedTitleName + `-${this.$t("Peak envelope")}（m/s^2）`,
        name: `${this.$t("Peak envelope")}（m/s^2）`,
        nameType: this.$t("Waveform graph"),

        legend: [
          this.$t("X-directional vibration"),
          this.$t("Y-directional vibration")
        ],
        data: data2.map(item => {
          return item[1] / 2;
        }),
        date: data2.map(items => {
          return Number(items[0]).toFixed(3);
        }),
        max: 10,
        min: 0,

        threshold: 2000,
        color: "#7CFFB2",

        chartDom: this.screw_pump_m_id
      };
      HighlineChart(option);
    },
    chartFour() {
      let xData = [
        "2022-09-17 00:34:26",
        "2022-09-18 10:34:41",
        "2022-09-26 02:41:42",
        "2022-09-28 12:44:46",
        "2022-10-03 03:44:46",
        "2022-10-08 22:14:26",
        "2022-10-15 00:44:46"
      ];
      let yData = [55, 46, 42, 45, 57, 53, 58];
      let option = {
        // name: this.selectedTitleName + this.$t("Bearing temperature") + "（℃）",
        name: this.$t("Bearing temperature") + "（℃）",
        nameType: "",
        legend: [
          this.$t("X-directional vibration"),
          this.$t("Y-directional vibration")
        ],
        date: xData,
        data: yData,
        max: 70,
        min: 0,

        threshold: 70,
        color: "#FFD402",

        chartDom: this.screw_pump_id
      };
      HighlineChart(option);
    }
  },
  components: {
    Select
  }
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.shockData {
  height: 100%;
  display: flex;
  flex-flow: column;
  .chart-list {
    margin-top: 15px;
    flex: 1;
    display: flex;
    flex-flow: column;
    .chart {
      flex: 1;
      margin-bottom: 10px;
      &:nth-last-of-type(1) {
        border-bottom: 0;
        margin-bottom: 0;
      }
    }
  }
}
</style>
